// LP Donate Modal — opens Bloomerang hosted donation page in branded popup
// Triggered by any <a href="#donate"> or element with class "js-donate-open"
(function() {
  var initialized = false;
  var widgetLoaded = false;

  function init() {
    if (initialized) return;
    var modal = document.getElementById('lp-donate-modal');
    if (!modal) return;
    initialized = true;

    window.lpOpenDonateModal = function() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lp-modal-open');
      if (!widgetLoaded) {
        var host = document.getElementById('lp-donate-widget-host');
        if (host) {
          var url = host.getAttribute('data-donate-url');
          if (url) {
            var iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.title = 'Donate to My Bag My Story';
            iframe.setAttribute('loading', 'lazy');
            iframe.setAttribute('allow', 'payment');
            host.appendChild(iframe);
          }
        }
        widgetLoaded = true;
      }
    };

    window.lpCloseDonateModal = function() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lp-modal-open');
    };

    // Click outside content closes modal
    modal.addEventListener('click', function(e) {
      if (e.target === modal) window.lpCloseDonateModal();
    });

    // Close button (in case inline onclick fails)
    var closeBtn = modal.querySelector('.lp-donate-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.lpCloseDonateModal();
      });
    }

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        window.lpCloseDonateModal();
      }
    });
  }

  // Global click delegate — works even before init
  document.addEventListener('click', function(e) {
    var a = e.target.closest('a, button');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var isOpener = (href === '#donate')
      || (href && href.indexOf('#donate') !== -1)
      || a.classList.contains('js-donate-open')
      || a.getAttribute('data-action') === 'donate';
    if (isOpener) {
      e.preventDefault();
      if (!initialized) init();
      if (window.lpOpenDonateModal) {
        window.lpOpenDonateModal();
      } else {
        console.warn('[LP Donate] Modal not found on page');
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
